import React, { useState } from 'react'
import { connect } from 'react-redux'
import './index.css'
import IconUrl from '../../../../../asset/User-Profile_Solid_E5E5E5_SVG.png'

const CancelSubscriptionSuccess = props => {

    return (
        <div className='cancel-sub-success-container'>
            <div className='left-expanded-header-container'>
                <span className='left-expanded-header'
                    style={{
                        justifyContent: 'left',
                        marginLeft: '20px'
                    }}>Success</span>
                <div className='default-close-back-arrow left-dialog-close' onClick={() => { props.closeMenu() }}></div>
            </div>

            <div className='cancel-success-container' style={{ display: 'flex', flexDirection: 'column' }}>

                <p style={{ color: '#C4C4C4' }}>You have canceled a subscription from:</p>

                <div className="sub-img-container">
                    <img
                        style={{ width: '100%' }}
                        src={props.cancelSubscriptionData?.imageProfileUrl || IconUrl}
                        alt="avatar"
                        onError={(e) => {
                            e.currentTarget.onerror = null; // prevent infinite loop
                            e.currentTarget.src = IconUrl;  // fallback
                        }}
                    />
                </div>

                <h3 style={{ color: '#FBFBFB' }}>{props.cancelSubscriptionData.fullName}</h3>

                <h3 style={{ color: '#959595' }}>{props.cancelSubscriptionData.email}</h3>

            </div>
        </div>
    )
}
const mapStateToProps = state => ({
    auth: state.auth,
    user: state.user
})

const mapDispatchToProps = dispatch => ({

})

export default connect(mapStateToProps, mapDispatchToProps)(CancelSubscriptionSuccess)
